import React, { Component } from "react";
import { toggleGoogleTranslate, changeGoogleTranslateLanguage } from "../../../actions/globalAction";
import { showOriginalText, changeLanguage, clearTranslate, languageOptions } from "../gtUtils";
import { connect } from "react-redux";
import { Radio, Dropdown } from "semantic-ui-react";
import { ReactComponent as Translate } from "../../../assets/translate.svg";
import "./GoogleTranslate.scss";
import Icon from "semantic-ui-react/dist/es/elements/Icon";
import Scrollbars from "react-custom-scrollbars";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { toast } from "react-toastify";

class GoogleTranslateComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectorOpen: false,
            open: false,
            disabled: false,
        };
    }

    componentDidMount() {
        // this.googleTranslateElementInit();
        if (this.props.translateToggle) {
            this.setState({ disabled: true });
        }
        var addScript = document.createElement("script");
        addScript.setAttribute("src", "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit");
        document.body.appendChild(addScript);
        window.googleTranslateElementInit = this.googleTranslateElementInit();
    }

    createNewGoogleTranslateObj() {
        new window.google.translate.TranslateElement(
            {
                pageLanguage: "en",
                layout: 2,
                autoDisplay: false,
                multilanguagePage: true,
                includedLanguages: "ar,de,en,es,id,ja,my,th,zh-TW,ms,tl,vi",
                defaultLanguage: "en",
            },
            "google_translate_element",
        );
        if (this.props.translateToggle === true) {
            setTimeout(() => changeLanguage(this.props.language), 5000);
        } else {
            setTimeout(() => showOriginalText(), 5000);
        }
    }

    googleTranslateElementInit() {
        // clearTranslate()
        try {
            this.createNewGoogleTranslateObj();
            console.log("success");
        } catch (e) {
            console.log("retrying");
            // console.log("error in google translate initializing", e);
            setTimeout(() => this.googleTranslateElementInit(), 2000);
        }
    }

    handleLanguageChange(val) {
        this.props.changeGoogleTranslateLanguage(val);
        changeLanguage(val);
        this.forceUpdate();
    }

    isFirefox() {
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.includes("firefox") || userAgent.includes("fxios");
    }

    toggleGoogleTranslate(e) {
        e?.stopPropagation();
        if (this.props.translateToggle === true) {
            showOriginalText();
            sessionStorage.removeItem("googleTranslate");
            sessionStorage.removeItem("selectedLanguage");
            this.setState({ selectorOpen: false });
            this.setState({ open: false });
        } else if (this.props.translateToggle === false) {
            sessionStorage.setItem("googleTranslate", true);
            this.handleLanguageChange("en");
        }
        this.props.toggleGoogleTranslate();
    }

    componentWillUnmount() {
        clearTranslate();
    }

    render() {
        const selectedLanguage = languageOptions.find((l) => l.value === this.props.language);

        return (
            <>
                {this.state.disabled ? (
                    <Popup
                        className="skiptranslate"
                        inverted
                        size="mini"
                        content="Translate"
                        position="top center"
                        trigger={
                            <Translate
                                onClick={() => {
                                    showOriginalText();
                                    sessionStorage.removeItem("googleTranslate");
                                    sessionStorage.removeItem("selectedLanguage");
                                    this.setState({ open: false, disabled: false, selectorOpen: false });
                                    this.props.toggleGoogleTranslate();
                                }}
                                title="Translate"
                                className={`navbar-translate-icon ${this.props.translateToggle ? "active" : ""}`}
                            />
                        }
                    />
                ) : (
                    <Dropdown
                        className={`google-translate-container ${this.isFirefox() ? "disable__content" : ""}`}
                        trigger={
                            <Popup
                                className="skiptranslate"
                                inverted
                                size="mini"
                                content={this.isFirefox() ? "Translate feature is not supported in FireFox" : "Translate"}
                                position="top center"
                                trigger={
                                    <Translate
                                        title={this.isFirefox() ? "" : "Translate"}
                                        className={`navbar-translate-icon ${this.props.translateToggle ? "active" : ""} ${
                                            this.isFirefox() ? "disable__content" : ""
                                        }`}
                                    />
                                }
                            />
                        }
                        pointing="top center"
                        closeOnChange={false}
                        icon={null}
                        open={this.state.open}
                        // disabled={this.state.disabled}
                        onClick={() => {
                            if (this.isFirefox()) {
                                console.log("This is Firefox browser.");
                                // toast.error("Translate feature is not supported in FireFox");
                                return;
                            }
                            if (!this.props.translateToggle) {
                                this.props.toggleGoogleTranslate();
                                sessionStorage.setItem("googleTranslate", true);
                                this.handleLanguageChange("en");
                            }
                        }}
                        onOpen={() => {
                            if (this.isFirefox()) {
                                return;
                            }
                            this.setState({ open: true, selectorOpen: true });
                        }}
                        onClose={() => this.setState({ open: false, disabled: true })}>
                        <Dropdown.Menu onClick={(e) => e.stopPropagation()}>
                            <div className="google-translate-dropdown skiptranslate" onClick={(e) => e.stopPropagation()}>
                                <div className="toggle-bar" onClick={() => this.toggleGoogleTranslate()}>
                                    <Translate />
                                    <span>Translate</span>
                                    <div className="toggle-bar-radio">
                                        <Radio toggle checked={this.props.translateToggle} onClick={(e) => e.stopPropagation()} />
                                        <div></div>
                                    </div>
                                </div>
                                {this.props.translateToggle && selectedLanguage && (
                                    <div className="language-selector">
                                        <div
                                            className={`selected-language ${this.state.selectorOpen ? "active" : ""} ${
                                                this.props.translateToggle ? "" : "disabled"
                                            }`}
                                            onClick={() => {
                                                if (!this.props.translateToggle) return;
                                                this.setState({ selectorOpen: !this.state.selectorOpen });
                                            }}>
                                            <span>{selectedLanguage.text}</span>
                                            <Icon name="dropdown" />
                                        </div>
                                        {this.state.selectorOpen && (
                                            <div className="language-selector-items">
                                                <Scrollbars
                                                    renderTrackHorizontal={(props) => (
                                                        <div {...props} style={{ display: "none" }} className="track-horizontal" />
                                                    )}>
                                                    {languageOptions.map((l) => {
                                                        return (
                                                            <div
                                                                key={l.value}
                                                                onClick={() => {
                                                                    this.handleLanguageChange(l.value);
                                                                    this.setState({ open: false, disabled: true });
                                                                }}
                                                                className={`language-selector-item ${this.props.language === l.value ? "active" : ""}`}>
                                                                {l.text}
                                                            </div>
                                                        );
                                                    })}
                                                </Scrollbars>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        translateToggle: state.globalReducer.translateToggle,
        language: state.globalReducer.googlelang,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleGoogleTranslate: () => dispatch(toggleGoogleTranslate()),
        changeGoogleTranslateLanguage: (val) => dispatch(changeGoogleTranslateLanguage(val)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GoogleTranslateComponent);
